import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M612 36.004L576.521.603 306 270.608 35.478.603 0 36.004l270.522 270.007L0 575.997l35.478 35.4L306 341.411l270.521 269.986 35.479-35.4-270.541-269.986z" /></svg>;